import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  ReactMediaRecorder,
  useReactMediaRecorder,
} from "react-media-recorder";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "../common/Modal";
import Button from "../sub-component/Button";
import Select from "../sub-component/Select";
import ProgressBar from "../common/ProgressBar";
import ProcessingIndicator from "../common/ProcessingIndicator";
import { addVideoStreamToVideoTag } from "../../utils/utilities";
import { getResource } from "../../redux/thunks/Resource";
import SpeechProgress from "./SpeechProgress";
import { ReactComponent as CamIcon } from "../../assets/icons/candidate-assessment/video.svg";
import { ReactComponent as CheckIcon } from "../../assets/icons/candidate-assessment/check.svg";
import { ReactComponent as StopIcon } from "../../assets/icons/candidate-assessment/square.svg";
import { ReactComponent as PlayIcon } from "../../assets/icons/candidate-assessment/play-r.svg";
import { ReactComponent as StartIcon } from "../../assets/icons/candidate-assessment/circle.svg";
import { ReactComponent as PauseIcon } from "../../assets/icons/candidate-assessment/pause-r.svg";
import { ReactComponent as UploadIcon } from "../../assets/icons/candidate-assessment/upload.svg";
import { ReactComponent as MicIcon } from "../../assets/icons/candidate-assessment/microphone.svg";
import { ReactComponent as RecordAgainIcon } from "../../assets/icons/candidate-assessment/rotate.svg";
import { ReactComponent as CirclePlayIcon } from "../../assets/icons/candidate-assessment/circlePlay.svg";
import { ReactComponent as CirclePauseIcon } from "../../assets/icons/candidate-assessment/circlePause.svg";

function LiveStreamPreview({
  stream,
  status,
  startRecording,
  stopRecording,
  videoDevices,
  audioDevices,
  selectedVideo,
  setSelectedVideo,
  selectedAudio,
  setSelectedAudio,
  recordedVideoDuration,
  recordingDuration,
  isPersonalityTest,
  startListening,
  stopListening,
  resetTranscriptData,
  progress,
  message,
  isSomthingIsInProcess,
  variant,
}) {
  const streamRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);

  // 🧠 Save selected device when changed manually (inside your <Select> handlers)
  const handleVideoSelect = (option) => {
    setSelectedVideo(option);
    localStorage.setItem("selectedVideoDevice", option.value);
  };

  const handleAudioSelect = (option) => {
    setSelectedAudio(option);
    localStorage.setItem("selectedAudioDevice", option.value);
  };

  useEffect(() => {
    if (streamRef.current && stream) {
      streamRef.current.srcObject = stream;
    }
  }, [stream]);

  if (!stream) {
    return <span>No stream available</span>;
  }

  if (status === "recording") {
    setTimeout(() => {
      setCurrentTime(currentTime + 1);
    }, 1000);
  }

  return (
    <>
      <div className="video-wrapper">
        <video
          ref={streamRef}
          autoPlay
          muted
          playsInline
          className="video-preview"
          onTimeUpdate={() => {
            if (status === "recording" && currentTime >= recordingDuration) {
              recordedVideoDuration(currentTime);
              stopRecording();
            }
          }}
        />
      </div>

      {/* 🎤 SpeechToText + footer UI from your code stays the same */}
      {(status === "idle" || status === "recording") && isPersonalityTest && (
        <div className="w-100">
          <SpeechProgress progress={progress} message={message} />
        </div>
      )}

      {variant === "testing" ? (
        <>
          <div className="camera-container-footer-testing">
            {status === "idle" ? (
              <Button
                btn="ragular-btn"
                varrient="primary-light"
                preIcon={
                  status === "idle" ? (
                    <StartIcon />
                  ) : status === "recording" ? (
                    <StopIcon />
                  ) : (
                    <RecordAgainIcon />
                  )
                }
                title={
                  status === "idle"
                    ? "Start recording"
                    : status === "recording"
                      ? "Stop recording"
                      : "Record again"
                }
                disabled={isSomthingIsInProcess}
                onClick={
                  status === "idle"
                    ? () => {
                        startRecording();
                      }
                    : status === "recording"
                      ? () => {
                          recordedVideoDuration(currentTime);
                          stopRecording();
                        }
                      : startRecording
                }
              />
            ) : (
              <div
                className="paly-pause-btn"
                onClick={() => {
                  recordedVideoDuration(currentTime);
                  stopRecording();
                }}
              >
                <StopIcon style={{ marginRight: "10px" }} />
                <span className="body-2 dark-50">
                  {`${
                    currentTime === 0
                      ? "00:00"
                      : `${
                          parseInt(currentTime / 60) < 10
                            ? "0" + parseInt(currentTime / 60)
                            : parseInt(currentTime / 60)
                        }:${
                          currentTime - 60 * parseInt(currentTime / 60) < 10
                            ? "0" +
                              `${currentTime - 60 * parseInt(currentTime / 60)}`
                            : currentTime - 60 * parseInt(currentTime / 60)
                        }`
                  }
									/
									${
                    parseInt(recordingDuration / 60) < 10
                      ? "0" + parseInt(recordingDuration / 60)
                      : parseInt(recordingDuration / 60)
                  }:${
                    recordingDuration - 60 * parseInt(recordingDuration / 60) <
                    10
                      ? "0" +
                        `${parseInt(
                          recordingDuration -
                            60 * parseInt(recordingDuration / 60),
                        )}`
                      : recordingDuration -
                        60 * parseInt(recordingDuration / 60)
                  }
								`}
                </span>
              </div>
            )}
          </div>
        </>
      ) : (
        <div className="camera-container-footer">
          {status === "idle" ? (
            <Button
              btn="ragular-btn"
              varrient="primary-light"
              // size="sm"
              preIcon={
                status === "idle" ? (
                  <StartIcon />
                ) : status === "recording" ? (
                  <StopIcon />
                ) : (
                  <RecordAgainIcon />
                )
              }
              title={
                status === "idle"
                  ? "Start recording"
                  : status === "recording"
                    ? "Stop recording"
                    : "Record again"
              }
              disabled={isSomthingIsInProcess}
              onClick={
                status === "idle"
                  ? () => {
                      startRecording();
                      if (isPersonalityTest) {
                        startListening();
                      }
                    }
                  : status === "recording"
                    ? () => {
                        recordedVideoDuration(currentTime);
                        stopRecording();
                        if (isPersonalityTest) {
                          stopListening();
                        }
                      }
                    : startRecording
              }
            />
          ) : (
            <div
              className="paly-pause-btn"
              onClick={() => {
                recordedVideoDuration(currentTime);
                stopRecording();
                if (isPersonalityTest) {
                  stopListening();
                }
              }}
            >
              <StopIcon style={{ marginRight: "10px" }} />
              <span className="body-2 dark-50">
                {`${
                  currentTime === 0
                    ? "00:00"
                    : `${
                        parseInt(currentTime / 60) < 10
                          ? "0" + parseInt(currentTime / 60)
                          : parseInt(currentTime / 60)
                      }:${
                        currentTime - 60 * parseInt(currentTime / 60) < 10
                          ? "0" +
                            `${currentTime - 60 * parseInt(currentTime / 60)}`
                          : currentTime - 60 * parseInt(currentTime / 60)
                      }`
                }
									/
									${
                    parseInt(recordingDuration / 60) < 10
                      ? "0" + parseInt(recordingDuration / 60)
                      : parseInt(recordingDuration / 60)
                  }:${
                    recordingDuration - 60 * parseInt(recordingDuration / 60) <
                    10
                      ? "0" +
                        `${parseInt(
                          recordingDuration -
                            60 * parseInt(recordingDuration / 60),
                        )}`
                      : recordingDuration -
                        60 * parseInt(recordingDuration / 60)
                  }
								`}
              </span>
            </div>
          )}
        </div>
      )}

      <div className="device-selector-contaner">
        <div className="device-selector">
          {/* Camera selector */}
          <Select
            readOnly
            disabled={status === "recording"}
            varrient={"select-with-pre-icon"}
            options={videoDevices.map(({ label, deviceId }) => ({
              name: label || "Camera",
              value: deviceId,
            }))}
            onSelection={(option) => handleVideoSelect(option)}
            selected={
              videoDevices.find((d) => d.deviceId === selectedVideo?.value)
                ?.label || "Camera"
            }
            preIcon={<CamIcon />}
          />

          {/* Mic selector */}
          <Select
            readOnly
            disabled={status === "recording"}
            varrient={"select-with-pre-icon"}
            options={audioDevices.map(({ label, deviceId }) => ({
              name: label || "Microphone",
              value: deviceId,
            }))}
            onSelection={(option) => handleAudioSelect(option)}
            selected={
              audioDevices.find((d) => d.deviceId === selectedAudio?.value)
                ?.label || "Microphone"
            }
            preIcon={<MicIcon />}
          />
        </div>
      </div>
    </>
  );
}

function useCustomRecorder({ onStop }) {
  const [status, setStatus] = useState("idle");
  const [mediaBlobUrl, setMediaBlobUrl] = useState(null);
  const [mediaBlob, setMediaBlob] = useState(null);

  const mediaRecorderRef = useRef(null);
  const chunksRef = useRef([]);

  const startRecording = (stream) => {
    if (!stream) return console.warn("No media stream to record");

    chunksRef.current = [];
    mediaRecorderRef.current = new MediaRecorder(stream, {
      mimeType: "video/webm",
    });

    mediaRecorderRef.current.ondataavailable = (e) => {
      if (e.data.size > 0) chunksRef.current.push(e.data);
    };

    mediaRecorderRef.current.onstop = () => {
      const blob = new Blob(chunksRef.current, { type: "video/webm" });
      const url = URL.createObjectURL(blob);
      setMediaBlob(blob);
      setMediaBlobUrl(url);

      onStop?.(blob, url); // still call your callback
    };

    mediaRecorderRef.current.start();
    setStatus("recording");
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && status === "recording") {
      mediaRecorderRef.current.stop();
      setStatus("stopped");
    }
  };

  const clearBlobUrl = () => {
    chunksRef.current = [];
    setMediaBlob(null);
    if (mediaBlobUrl) URL.revokeObjectURL(mediaBlobUrl);
    setMediaBlobUrl(null);
    setStatus("idle");
  };

  return {
    status,
    startRecording,
    stopRecording,
    clearBlobUrl,
    mediaBlob,
    mediaBlobUrl,
  };
}

export default function VideoRecorder(props) {
  const {
    variant,
    recordingDuration,
    isSomthingIsInProcess,
    setPVRDuration,
    startListening,
    stopListening,
    onStatusChange,
    uploadProgress,
    isPersonalityTest,
    resetTranscriptData,
    progress,
    message,
  } = props;

  const video_Ref = useRef();
  const dispatch = useDispatch();
  const [recorderKey, setRecorderKey] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [videoDevices, setVideoDevices] = useState([]);
  const [audioDevices, setAudioDevices] = useState([]);
  const [customStream, setCustomStream] = useState(null);
  const [onRetryModal, setOnRetryModal] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [selectedAudio, setSelectedAudio] = useState(null);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [isVideoUploading, setIsVideoUploading] = useState(false);
  const [recorderVideoDuration, setRecorderVideoDuration] = useState(0);

  const resource = useSelector((state) => state.resourceReducer);

  const onRecordStop = (blobURL, blob) => {
    var fileOfBlob = new File([blob], `Recorded-${Math.random() * 10}-version`);
    //startRecording();
  };

  const {
    status,
    startRecording,
    stopRecording,
    clearBlobUrl,
    mediaBlob,
    mediaBlobUrl,
  } = useCustomRecorder({
    onStop: onRecordStop,
  });

  // Propagate recorder status changes to parent so it can enable actions (e.g., submit button)
  useEffect(() => {
    if (onStatusChange) {
      onStatusChange(status);
    }
  }, [status, onStatusChange]);

  // 🎥 Fetch devices on mount
  useEffect(() => {
    const getDevices = async () => {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoInputs = devices.filter((d) => d.kind === "videoinput");
        const audioInputs = devices.filter((d) => d.kind === "audioinput");

        setVideoDevices(videoInputs);
        setAudioDevices(audioInputs);

        // Get saved selections
        const savedVideoId = localStorage.getItem("selectedVideoDevice");
        const savedAudioId = localStorage.getItem("selectedAudioDevice");

        // Helper to find device safely
        const findDevice = (devices, id) =>
          devices.find((d) => d.deviceId === id) || null;

        // Set selected video device
        if (videoInputs.length > 0) {
          const matchedVideo = findDevice(videoInputs, savedVideoId);
          if (matchedVideo) {
            setSelectedVideo({ value: matchedVideo.deviceId });
          } else {
            // Fallback to first available video device
            const defaultVideo = videoInputs[0];
            setSelectedVideo({ value: defaultVideo.deviceId });
            localStorage.setItem("selectedVideoDevice", defaultVideo.deviceId);
          }
        }

        // Set selected audio device
        if (audioInputs.length > 0) {
          const matchedAudio = findDevice(audioInputs, savedAudioId);
          if (matchedAudio) {
            setSelectedAudio({ value: matchedAudio.deviceId });
          } else {
            // Fallback to first available audio device
            const defaultAudio = audioInputs[0];
            setSelectedAudio({ value: defaultAudio.deviceId });
            localStorage.setItem("selectedAudioDevice", defaultAudio.deviceId);
          }
        }
      } catch (err) {
        console.error("Error fetching devices:", err);
      }
    };

    getDevices();
  }, []);

  // 🎤🎥 Update stream when device selection changes
  useEffect(() => {
    const updateStream = async () => {
      if (!selectedVideo && !selectedAudio) return;
      try {
        if (customStream) {
          customStream.getTracks().forEach((t) => t.stop());
        }

        const stream = await navigator.mediaDevices.getUserMedia({
          video: selectedVideo
            ? { deviceId: { exact: selectedVideo.value } }
            : true,
          audio: selectedAudio
            ? { deviceId: { exact: selectedAudio.value } }
            : true,
        });

        setCustomStream(stream);
        if (video_Ref.current) video_Ref.current.srcObject = stream;
      } catch (err) {
        console.error("Error creating stream:", err);
      }
    };

    updateStream();
  }, [selectedVideo, selectedAudio]);

  // useEffect(() => {
  //   if (!mediaBlobUrl && status !== "stopped") return;

  //   if (props.onVideoSubmit) {
  //     props.onVideoSubmit(mediaBlobUrl);
  //   }
  // }, [mediaBlobUrl]);

  useEffect(() => {
    if (localStorage.getItem("video_recorder_id")) {
      dispatch(
        getResource({
          id: localStorage.getItem("video_recorder_id"),
        }),
      );
    }
  }, []);

  return (
    <>
      {/* 🔁 Your Retry Modal code here (unchanged) */}
      {
        <CustomModal
          open={onRetryModal}
          varrient="alert-warning-modal"
          title="Record Again?"
          description={
            "Are you sure, you want to record a new video for this question?"
          }
          warningAlert={true}
          warningText={
            "Warning: By doing this your previous video recording will be replaced!"
          }
          handleCloseModal={() => {
            setOnRetryModal(false);
          }}
          confirmBtnTitle={"Yes, Record Again"}
          btnWidth="max-content"
          onConfirm={() => {
            if (props.onRetry) {
              props.onRetry();
            }
            // startRecording();
            clearBlobUrl();
            setRecorderKey((k) => k + 1);
            setOnRetryModal(false);
            setIsVideoUploading(false);
            if (isPersonalityTest) {
              resetTranscriptData();
            }
          }}
        />
      }

      {localStorage.getItem("video_recorder_id") ? (
        <div
          id="demo"
          className="video-recorder-container"
          style={{ height: props.height ? props.height : "100%" }}
        >
          <video
            src={resource?.data?.url}
            style={{ borderRadius: "10px 10px 0 0" }}
            className="video-recorder"
            controls={true}
            muted={false}
            disablePictureInPicture={true}
            controlsList="nodownload noremoteplayback noplaybackrate"
          />
          <div
            className="w-100 d-flex flex-column align-items-center justify-content-center"
            style={{ gap: "12px" }}
          >
            <div className="camera-container-footer">
              <div
                className="w-100 d-flex flex-column align-items-center justify-content-center"
                style={{ gap: "5px" }}
              >
                <CheckIcon />
                <span className="body-2 white">Upload Done</span>
                <span className="body-4 dark-50">
                  Now you may submit this video.
                </span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          id="demo"
          className="video-recorder-container"
          style={{ height: props.height ? props.height : "100%" }}
        >
          {customStream && (status === "idle" || status === "recording") ? (
            <LiveStreamPreview
              stream={customStream}
              status={status}
              isSomthingIsInProcess={isSomthingIsInProcess}
              startRecording={() => startRecording(customStream)}
              stopListening={stopListening}
              startListening={startListening}
              stopRecording={stopRecording}
              recordingDuration={recordingDuration}
              variant={variant}
              recordedVideoDuration={(duration) => {
                setRecorderVideoDuration(duration);
                if (setPVRDuration) {
                  setPVRDuration(duration);
                }
              }}
              isPersonalityTest={isPersonalityTest}
              resetTranscriptData={resetTranscriptData}
              progress={progress}
              message={message}
              selectedVideo={selectedVideo}
              setSelectedVideo={setSelectedVideo}
              selectedAudio={selectedAudio}
              setSelectedAudio={setSelectedAudio}
              customStream={customStream}
              setCustomStream={setCustomStream}
              videoDevices={videoDevices}
              audioDevices={audioDevices}
            />
          ) : (
            <video
              ref={video_Ref}
              src={mediaBlobUrl}
              autoPlay={true}
              style={{ borderRadius: "10px 10px 0 0" }}
              className="video-recorder"
              controls={true}
              onTimeUpdate={() => {
                setCurrentTime(Math.floor(video_Ref?.current?.currentTime));
              }}
              onEnded={() => {
                setIsVideoPlaying(false);
              }}
              onPlay={() => {
                setIsVideoPlaying(true);
              }}
              onPause={() => {
                setIsVideoPlaying(false);
              }}
            />
          )}

          {/* Personality test / Upload status footer UI (unchanged from your code) */}
          {status === "stopped" && isPersonalityTest && (
            <div className="w-100">
              <SpeechProgress progress={progress} message={message} />
            </div>
          )}
          {variant === "testing" ? (
            <>
              {status === "stopped" && (
                <div className="camera-container-footer-testing">
                  {props.processingUpload ? (
                    <>
                      <ProgressBar
                        varrient={"progress-with-upload-doc"}
                        value={resource?.upload_percentage}
                      />
                    </>
                  ) : (
                    <Button
                      btn="ragular-btn"
                      varrient="primary-light"
                      preIcon={
                        status === "idle" ? <StartIcon /> : <RecordAgainIcon />
                      }
                      title={
                        status === "idle" ? "Start recording" : "Record again"
                      }
                      disabled={isSomthingIsInProcess}
                      onClick={
                        status === "idle"
                          ? startRecording
                          : () => {
                              setOnRetryModal(true);
                            }
                      }
                    />
                  )}
                </div>
              )}
            </>
          ) : (
            <>
              {status === "stopped" && (
                <div
                  className="w-100 d-flex flex-column align-items-center justify-content-center"
                  style={{ gap: "12px" }}
                >
                  <div
                    className="camera-container-footer"
                    style={{
                      height:
                        isPersonalityTest && (progress || 0) < 100 && "120px",
                    }}
                  >
                    {isPersonalityTest ? (
                      <>
                        {(progress || 0) < 100 ? (
                          <div
                            className="w-100 d-flex flex-column align-items-center justify-content-center"
                            style={{ gap: "16px" }}
                          >
                            <span className="body-1 white">
                              {`Almost there! Try re-recording and give a more
                            complete answer — the progress bar will let you know
                            when you're good to go.`}
                            </span>
                            <Button
                              btn="ragular-btn"
                              varrient="primary-light"
                              preIcon={
                                status === "idle" ? (
                                  <StartIcon />
                                ) : (
                                  <RecordAgainIcon />
                                )
                              }
                              title={
                                status === "idle"
                                  ? "Start recording"
                                  : "Record again"
                              }
                              disabled={isSomthingIsInProcess}
                              onClick={
                                status === "idle"
                                  ? startRecording
                                  : () => {
                                      setOnRetryModal(true);
                                    }
                              }
                            />
                          </div>
                        ) : (
                          <>
                            {!isVideoUploading ? (
                              <div
                                className="w-100 d-flex flex-row align-items-center justify-content-center"
                                style={{ gap: "5px" }}
                              >
                                <Button
                                  btn="ragular-btn"
                                  varrient="secondary-light"
                                  preIcon={
                                    status === "idle" ? (
                                      <StartIcon />
                                    ) : (
                                      <RecordAgainIcon />
                                    )
                                  }
                                  title={
                                    status === "idle"
                                      ? "Start recording"
                                      : "Record again"
                                  }
                                  disabled={isSomthingIsInProcess}
                                  onClick={
                                    status === "idle"
                                      ? startRecording
                                      : () => {
                                          setOnRetryModal(true);
                                        }
                                  }
                                />
                                <Button
                                  btn="ragular-btn"
                                  varrient="primary-light"
                                  preIcon={<UploadIcon />}
                                  title={"Upload Video"}
                                  disabled={isSomthingIsInProcess}
                                  onClick={() => {
                                    props.onVideoSubmit(mediaBlobUrl);
                                    setIsVideoUploading(true);
                                  }}
                                />
                              </div>
                            ) : (
                              <>
                                {props.processingUpload ? (
                                  <ProgressBar
                                    varrient={"progress-with-upload-doc"}
                                    value={resource?.upload_percentage}
                                  />
                                ) : (
                                  <div
                                    className="w-100 d-flex flex-column align-items-center justify-content-center"
                                    style={{ gap: "5px" }}
                                  >
                                    <CheckIcon />
                                    <span className="body-2 white">
                                      Upload Done
                                    </span>
                                    <span className="body-4 dark-50">
                                      Now you may submit this video.
                                    </span>
                                  </div>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        {!isVideoUploading ? (
                          <div
                            className="w-100 d-flex flex-row align-items-center justify-content-center"
                            style={{ gap: "5px" }}
                          >
                            <Button
                              btn="ragular-btn"
                              varrient="secondary-light"
                              preIcon={
                                status === "idle" ? (
                                  <StartIcon />
                                ) : (
                                  <RecordAgainIcon />
                                )
                              }
                              title={
                                status === "idle"
                                  ? "Start recording"
                                  : "Record again"
                              }
                              disabled={isSomthingIsInProcess}
                              onClick={
                                status === "idle"
                                  ? startRecording
                                  : () => {
                                      setOnRetryModal(true);
                                    }
                              }
                            />
                            <Button
                              btn="ragular-btn"
                              varrient="primary-light"
                              preIcon={<UploadIcon />}
                              title={"Upload Video"}
                              disabled={isSomthingIsInProcess}
                              onClick={() => {
                                props.onVideoSubmit(mediaBlobUrl);
                                setIsVideoUploading(true);
                              }}
                            />
                          </div>
                        ) : (
                          <>
                            {props.processingUpload ? (
                              <ProgressBar
                                varrient={"progress-with-upload-doc"}
                                value={resource?.upload_percentage}
                              />
                            ) : (
                              <div
                                className="w-100 d-flex flex-column align-items-center justify-content-center"
                                style={{ gap: "5px" }}
                              >
                                <CheckIcon />
                                <span className="body-2 white">
                                  Upload Done
                                </span>
                                <span className="body-4 dark-50">
                                  Now you may submit this video.
                                </span>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                  {/* <div className="w-100 d-flex align-items-center justify-content-center">
                  <Button
                    btn="ragular-btn"
                    varrient="secondary-light"
                    preIcon={
                      status === "idle" ? <StartIcon /> : <RecordAgainIcon />
                    }
                    title={
                      status === "idle" ? "Start recording" : "Record again"
                    }
                    disabled={isSomthingIsInProcess || props.processingUpload}
                    // disabled={isSomthingIsInProcess}
                    onClick={
                      status === "idle"
                        ? startRecording
                        : () => {
                            setOnRetryModal(true);
                          }
                    }
                  />
                </div> */}
                </div>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
}

///////////////////////////////////////////////////

// function LiveStreamPreview({
//   stream,
//   style,
//   // status,
//   // startRecording,
//   stopListening,
//   // stopRecording,
//   recordingDuration,
//   variant,
//   startListening,
//   recordedVideoDuration,
//   isSomthingIsInProcess,
//   isPersonalityTest,
//   resetTranscriptData,
//   progress,
//   message,
//   aItranscript,
//   hasStarted,
//   setAiTranscript,
//   setProgress,
//   setMessage,
//   targetCharacters,
//   resetKey,
//   transcript,
//   isSupportedSpeechBrowser,
//   wasStopped,
//   setWasStopped,
//   selectedVideo,
//   setSelectedVideo,
//   selectedAudio,
//   setSelectedAudio,
//   customStream,
//   setCustomStream,
//   videoDevices,
//   audioDevices,
// }) {
//   const streamRef = useRef(null);
//   const [currentTime, setCurrentTime] = useState(0);
//   // const [videoDevices, setVideoDevices] = useState([]);
//   // const [audioDevices, setAudioDevices] = useState([]);

//   // const getDevices = async () => {
//   //   try {
//   //     await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
//   //     const devices = await navigator.mediaDevices.enumerateDevices();

//   //     const _video = devices.filter((d) => d.kind === "videoinput");
//   //     const _audio = devices.filter((d) => d.kind === "audioinput");

//   //     setVideoDevices(_video);
//   //     setAudioDevices(_audio);

//   //     // auto select first available devices
//   //     if (!_video.length && !_audio.length) return;

//   //     if (!selectedVideo && _video[0]) {
//   //       setSelectedVideo({ name: _video[0].label, value: _video[0].deviceId });
//   //     }
//   //     if (!selectedAudio && _audio[0]) {
//   //       setSelectedAudio({ name: _audio[0].label, value: _audio[0].deviceId });
//   //     }
//   //   } catch (err) {
//   //     console.error("Permission denied:", err);
//   //   }
//   // };

//   // // Get stream with selected devices
//   // const updateStream = async () => {
//   //   if (!selectedVideo && !selectedAudio) return;

//   //   try {
//   //     const constraints = {
//   //       video: selectedVideo
//   //         ? { deviceId: { exact: selectedVideo.value } }
//   //         : false,
//   //       audio: selectedAudio
//   //         ? { deviceId: { exact: selectedAudio.value } }
//   //         : false,
//   //     };

//   //     const newStream = await navigator.mediaDevices.getUserMedia(constraints);

//   //     // stop old stream if any
//   //     if (customStream) {
//   //       customStream.getTracks().forEach((t) => t.stop());
//   //     }

//   //     setCustomStream(newStream);

//   //     // attach to preview
//   //     if (streamRef.current) {
//   //       streamRef.current.srcObject = newStream;
//   //     }
//   //   } catch (err) {
//   //     console.error("Error getting stream:", err);
//   //   }
//   // };

//   // // Fetch devices on mount
//   // useEffect(() => {
//   //   getDevices();
//   //   navigator.mediaDevices.ondevicechange = getDevices;
//   // }, []);

//   // // Update stream whenever device selection changes
//   // useEffect(() => {
//   //   updateStream();
//   // }, [selectedVideo, selectedAudio]);

//   const onRecordStop = (blobURL, blob) => {
//     var fileOfBlob = new File([blob], `Recorded-${Math.random() * 10}-version`);
//     //startRecording();
//   };

//   const { status, startRecording, stopRecording } = useReactMediaRecorder({
//     video: false,
//     audio: false,
//     customMediaStream: customStream,
//     onStop: onRecordStop,
//     askPermissionOnMount: false,
//     blobOptions: { type: "video/webm" },
//   });

//   // 🔹 Attach preview
//   useEffect(() => {
//     if (streamRef.current && customStream) {
//       streamRef.current.srcObject = customStream;
//     }
//   }, [customStream]);

//   if (!stream) {
//     return <span>No stream available</span>;
//   }

//   if (status === "recording") {
//     setTimeout(() => {
//       setCurrentTime(currentTime + 1);
//     }, 1000);
//   }

//   console.log(
//     status,
//     startRecording(),
//     selectedVideo,
//     selectedAudio,
//     stream,
//     customStream,
//     "log"
//   );

//   return (
//     <>
//       <div className="video-wrapper">
//         <video
//           ref={streamRef}
//           autoPlay
//           playsInline
//           className="video-preview"
//           onTimeUpdate={() => {
//             if (status === "recording" && currentTime >= recordingDuration) {
//               recordedVideoDuration(currentTime);
//               stopRecording();
//             }
//           }}
//         />
//       </div>

//       {(status === "idle" || status === "recording") && isPersonalityTest && (
//         <div className="w-100">
//           <SpeechToText
//             startListening={startListening}
//             stopListening={stopListening}
//             resetTranscriptData={resetTranscriptData}
//             progress={progress}
//             message={message}
//             aItranscript={aItranscript}
//             hasStarted={hasStarted}
//             setAiTranscript={setAiTranscript}
//             setProgress={setProgress}
//             setMessage={setMessage}
//             targetCharacters={targetCharacters}
//             resetKey={resetKey}
//             transcript={transcript}
//             isSupportedSpeechBrowser={isSupportedSpeechBrowser}
//             wasStopped={wasStopped}
//             setWasStopped={setWasStopped}
//             recordingDuration={currentTime}
//           />
//         </div>
//       )}

//       {variant === "testing" ? (
//         <>
//           <div className="camera-container-footer-testing">
//             {status === "idle" ? (
//               <Button
//                 btn="ragular-btn"
//                 varrient="primary-light"
//                 preIcon={
//                   status === "idle" ? (
//                     <StartIcon />
//                   ) : status === "recording" ? (
//                     <StopIcon />
//                   ) : (
//                     <RecordAgainIcon />
//                   )
//                 }
//                 title={
//                   status === "idle"
//                     ? "Start recording"
//                     : status === "recording"
//                     ? "Stop recording"
//                     : "Record again"
//                 }
//                 disabled={isSomthingIsInProcess}
//                 onClick={
//                   status === "idle"
//                     ? () => {
//                         startRecording();
//                       }
//                     : status === "recording"
//                     ? () => {
//                         recordedVideoDuration(currentTime);
//                         stopRecording();
//                       }
//                     : startRecording
//                 }
//               />
//             ) : (
//               <div
//                 className="paly-pause-btn"
//                 onClick={() => {
//                   recordedVideoDuration(currentTime);
//                   stopRecording();
//                 }}
//               >
//                 <StopIcon style={{ marginRight: "10px" }} />
//                 <span className="body-2 dark-50">
//                   {`${
//                     currentTime === 0
//                       ? "00:00"
//                       : `${
//                           parseInt(currentTime / 60) < 10
//                             ? "0" + parseInt(currentTime / 60)
//                             : parseInt(currentTime / 60)
//                         }:${
//                           currentTime - 60 * parseInt(currentTime / 60) < 10
//                             ? "0" +
//                               `${currentTime - 60 * parseInt(currentTime / 60)}`
//                             : currentTime - 60 * parseInt(currentTime / 60)
//                         }`
//                   }
// 									/
// 									${
//                     parseInt(recordingDuration / 60) < 10
//                       ? "0" + parseInt(recordingDuration / 60)
//                       : parseInt(recordingDuration / 60)
//                   }:${
//                     recordingDuration - 60 * parseInt(recordingDuration / 60) <
//                     10
//                       ? "0" +
//                         `${parseInt(
//                           recordingDuration -
//                             60 * parseInt(recordingDuration / 60)
//                         )}`
//                       : recordingDuration -
//                         60 * parseInt(recordingDuration / 60)
//                   }
// 								`}
//                 </span>
//               </div>
//             )}
//           </div>
//         </>
//       ) : (
//         <div className="camera-container-footer">
//           {status === "idle" ? (
//             <Button
//               btn="ragular-btn"
//               varrient="primary-light"
//               // size="sm"
//               preIcon={
//                 status === "idle" ? (
//                   <StartIcon />
//                 ) : status === "recording" ? (
//                   <StopIcon />
//                 ) : (
//                   <RecordAgainIcon />
//                 )
//               }
//               title={
//                 status === "idle"
//                   ? "Start recording"
//                   : status === "recording"
//                   ? "Stop recording"
//                   : "Record again"
//               }
//               disabled={isSomthingIsInProcess}
//               onClick={
//                 status === "idle"
//                   ? () => {
//                       startRecording();
//                       if (isPersonalityTest) {
//                         startListening();
//                       }
//                     }
//                   : status === "recording"
//                   ? () => {
//                       recordedVideoDuration(currentTime);
//                       stopRecording();
//                       if (isPersonalityTest) {
//                         stopListening();
//                       }
//                     }
//                   : startRecording
//               }
//             />
//           ) : (
//             <div
//               className="paly-pause-btn"
//               onClick={() => {
//                 recordedVideoDuration(currentTime);
//                 stopRecording();
//                 if (isPersonalityTest) {
//                   stopListening();
//                 }
//               }}
//             >
//               <StopIcon style={{ marginRight: "10px" }} />
//               <span className="body-2 dark-50">
//                 {`${
//                   currentTime === 0
//                     ? "00:00"
//                     : `${
//                         parseInt(currentTime / 60) < 10
//                           ? "0" + parseInt(currentTime / 60)
//                           : parseInt(currentTime / 60)
//                       }:${
//                         currentTime - 60 * parseInt(currentTime / 60) < 10
//                           ? "0" +
//                             `${currentTime - 60 * parseInt(currentTime / 60)}`
//                           : currentTime - 60 * parseInt(currentTime / 60)
//                       }`
//                 }
// 									/
// 									${
//                     parseInt(recordingDuration / 60) < 10
//                       ? "0" + parseInt(recordingDuration / 60)
//                       : parseInt(recordingDuration / 60)
//                   }:${
//                   recordingDuration - 60 * parseInt(recordingDuration / 60) < 10
//                     ? "0" +
//                       `${parseInt(
//                         recordingDuration -
//                           60 * parseInt(recordingDuration / 60)
//                       )}`
//                     : recordingDuration - 60 * parseInt(recordingDuration / 60)
//                 }
// 								`}
//               </span>
//             </div>
//           )}
//         </div>
//       )}
//       <div className="device-selector-contaner">
//         <div className="device-selector">
//           {/* Camera selector */}
//           <Select
//             readOnly={true}
//             disabled={status === "recording"}
//             varrient={"select-with-pre-icon"}
//             options={videoDevices.map(({ label, deviceId }) => ({
//               name: label || "Camera",
//               value: deviceId,
//             }))}
//             onSelection={(option) => setSelectedVideo(option)}
//             selected={
//               videoDevices.find((d) => d.deviceId === selectedVideo?.value)
//                 ?.label || "Camera"
//             }
//             placeholder=" "
//             preIcon={<CamIcon />}
//           />

//           {/* Mic selector */}
//           <Select
//             readOnly={true}
//             disabled={status === "recording"}
//             varrient={"select-with-pre-icon"}
//             options={audioDevices.map(({ label, deviceId }) => ({
//               name: label || "Microphone",
//               value: deviceId,
//             }))}
//             onSelection={(option) => setSelectedAudio(option)}
//             selected={
//               audioDevices.find((d) => d.deviceId === selectedAudio?.value)
//                 ?.label || "Microphone"
//             }
//             placeholder=" "
//             preIcon={<MicIcon />}
//           />
//         </div>
//       </div>
//     </>
//   );
// }

// export default function VideoRecorder(props) {
//   const {
//     variant,
//     recordingDuration,
//     isSomthingIsInProcess,
//     setPVRDuration,
//     startListening,
//     stopListening,
//     onStatusChange,
//     uploadProgress,
//     isPersonalityTest,
//     resetTranscriptData,
//     progress,
//     message,
//     aItranscript,
//     hasStarted,
//     setAiTranscript,
//     setProgress,
//     setMessage,
//     targetCharacters,
//     resetKey,
//     transcript,
//     isSupportedSpeechBrowser,
//     wasStopped,
//     setWasStopped,
//   } = props;

//   const video_Ref = useRef();
//   const [recorderKey, setRecorderKey] = useState(0);
//   const [currentTime, setCurrentTime] = useState(0);
//   const [videoDevices, setVideoDevices] = useState([]);
//   const [audioDevices, setAudioDevices] = useState([]);
//   const [customStream, setCustomStream] = useState(null);
//   const [onRetryModal, setOnRetryModal] = useState(false);
//   const [selectedVideo, setSelectedVideo] = useState(null);
//   const [selectedAudio, setSelectedAudio] = useState(null);
//   const [isVideoPlaying, setIsVideoPlaying] = useState(false);
//   const [recorderVideoDuration, setRecorderVideoDuration] = useState(0);

//   const resource = useSelector((state) => state.resourceReducer);

//   const onRecordStop = (blobURL, blob) => {
//     var fileOfBlob = new File([blob], `Recorded-${Math.random() * 10}-version`);
//     //startRecording();
//   };
//   const mediaKey = `${selectedVideo?.value || "default"}-${
//     selectedAudio?.value || "default"
//   }`;

//   // const {
//   //   status,
//   //   startRecording,
//   //   stopRecording,
//   //   mediaBlobUrl,
//   //   clearBlobUrl,
//   //   previewStream,
//   // } = useReactMediaRecorder(
//   //   {
//   //     video: selectedVideo
//   //       ? { deviceId: { exact: selectedVideo.value } }
//   //       : true,
//   //     audio: selectedAudio
//   //       ? { deviceId: { exact: selectedAudio.value } }
//   //       : true,
//   //     // audio: true,
//   //     // video: true,
//   //     onStop: onRecordStop,
//   //     askPermissionOnMount: true,
//   //     blobOptions: { type: "video/webm" },
//   //     // mediaStreamConstraints: customStream,
//   //   },
//   //   customStream,
//   //   mediaKey
//   // );

//   const getDevices = async () => {
//     try {
//       // Ask permission + get default stream right away
//       const defaultStream = await navigator.mediaDevices.getUserMedia({
//         video: true,
//         audio: true,
//       });

//       setCustomStream(defaultStream); // ensures recorder always has a stream

//       const devices = await navigator.mediaDevices.enumerateDevices();
//       const vids = devices.filter((d) => d.kind === "videoinput");
//       const mics = devices.filter((d) => d.kind === "audioinput");
//       setVideoDevices(vids);
//       setAudioDevices(mics);

//       // select defaults if not already chosen
//       if (!selectedVideo && vids[0])
//         setSelectedVideo({ name: vids[0].label, value: vids[0].deviceId });
//       if (!selectedAudio && mics[0])
//         setSelectedAudio({ name: mics[0].label, value: mics[0].deviceId });
//     } catch (err) {
//       console.error("Permission denied:", err);
//     }
//   };

//   const updateStream = async () => {
//     if (!selectedVideo && !selectedAudio) return;
//     try {
//       const constraints = {
//         video: selectedVideo
//           ? { deviceId: { exact: selectedVideo.value } }
//           : false,
//         audio: selectedAudio
//           ? { deviceId: { exact: selectedAudio.value } }
//           : false,
//       };
//       const stream = await navigator.mediaDevices.getUserMedia(constraints);
//       if (customStream) {
//         customStream.getTracks().forEach((t) => t.stop());
//       }
//       setCustomStream(stream);
//     } catch (err) {
//       console.error("Error updating stream:", err);
//     }
//   };

//   // Recorder hook – always uses the customStream only
//   const {
//     status,
//     startRecording,
//     stopRecording,
//     mediaBlobUrl,
//     clearBlobUrl,
//     previewStream,
//   } = useReactMediaRecorder(
//     {
//       video: false,
//       audio: false,
//       onStop: onRecordStop,
//       askPermissionOnMount: true,
//       blobOptions: { type: "video/webm" },
//       mediaStreamConstraints: customStream,
//     },
//     customStream
//   );

//   useEffect(() => {
//     getDevices(); // ensures first stream is set before recorder use
//     navigator.mediaDevices.ondevicechange = getDevices;
//   }, []);

//   useEffect(() => {
//     updateStream();
//   }, [selectedVideo, selectedAudio]);

//   useEffect(() => {
//     if (video_Ref.current && customStream) {
//       video_Ref.current.srcObject = customStream;
//     }
//   }, [customStream]);

//   // useEffect(() => {
//   //   if (onStatusChange) {
//   //     onStatusChange(status);
//   //   }
//   // }, [status]);

//   useEffect(() => {
//     if (!mediaBlobUrl && status !== "stopped") return;

//     if (props.onVideoSubmit) {
//       props.onVideoSubmit(mediaBlobUrl);
//     }
//   }, [mediaBlobUrl]);
//   console.log(status, selectedVideo, selectedAudio, customStream, "log");

//   return (
//     <>
//       {
//         <CustomModal
//           open={onRetryModal}
//           varrient="alert-warning-modal"
//           title="Record Again?"
//           description={
//             "Are you sure, you want to record a new video for this question?"
//           }
//           warningAlert={true}
//           warningText={
//             "Warning: By doing this your previous video recording will be replaced!"
//           }
//           handleCloseModal={() => {
//             setOnRetryModal(false);
//           }}
//           confirmBtnTitle={"Yes, Record Again"}
//           btnWidth="max-content"
//           onConfirm={() => {
//             if (props.onRetry) {
//               props.onRetry();
//             }
//             // startRecording();
//             clearBlobUrl();
//             setRecorderKey((k) => k + 1);
//             setOnRetryModal(false);
//             if (isPersonalityTest) {
//               resetTranscriptData();
//             }
//           }}
//         />
//       }

//       <div
//         id="demo"
//         className="video-recorder-container"
//         style={{ height: props.height ? props.height : "100%" }}
//       >
//         {/* status: {status.toString()}
// 			{(status === 'stopped' || status === 'idle') && (
// 				<button onClick={startRecording}>Start Recording</button>
// 			)}
// 			{status === 'recording' && (
// 				<button onClick={stopRecording}>Stop Recording</button>.
// 			)} */}
//         {customStream && (status === "idle" || status === "recording") ? (
//           <LiveStreamPreview
//             stream={customStream}
//             status={status}
//             isSomthingIsInProcess={isSomthingIsInProcess}
//             startRecording={startRecording}
//             stopListening={stopListening}
//             startListening={startListening}
//             stopRecording={stopRecording}
//             recordingDuration={recordingDuration}
//             variant={variant}
//             recordedVideoDuration={(duration) => {
//               setRecorderVideoDuration(duration);
//               if (setPVRDuration) {
//                 setPVRDuration(duration);
//               }
//             }}
//             isPersonalityTest={isPersonalityTest}
//             resetTranscriptData={resetTranscriptData}
//             progress={progress}
//             message={message}
//             aItranscript={aItranscript}
//             hasStarted={hasStarted}
//             setAiTranscript={setAiTranscript}
//             setProgress={setProgress}
//             setMessage={setMessage}
//             targetCharacters={targetCharacters}
//             resetKey={resetKey}
//             transcript={transcript}
//             isSupportedSpeechBrowser={isSupportedSpeechBrowser}
//             wasStopped={wasStopped}
//             setWasStopped={setWasStopped}
//             selectedVideo={selectedVideo}
//             setSelectedVideo={setSelectedVideo}
//             selectedAudio={selectedAudio}
//             setSelectedAudio={setSelectedAudio}
//             customStream={customStream}
//             setCustomStream={setCustomStream}
//             videoDevices={videoDevices}
//             audioDevices={audioDevices}
//           />
//         ) : (
//           // <></>
//           <>
//             <video
//               ref={video_Ref}
//               src={mediaBlobUrl}
//               autoPlay={true}
//               style={{ borderRadius: "10px 10px 0 0" }}
//               className="video-recorder"
//               controls={true}
//               onTimeUpdate={() => {
//                 setCurrentTime(Math.floor(video_Ref?.current?.currentTime));
//               }}
//               onEnded={() => {
//                 setIsVideoPlaying(false);
//               }}
//               onPlay={() => {
//                 setIsVideoPlaying(true);
//               }}
//               onPause={() => {
//                 setIsVideoPlaying(false);
//               }}
//             />
//           </>
//         )}
//         {status === "stopped" && isPersonalityTest && (
//           <div className="w-100">
//             <SpeechToText
//               startListening={startListening}
//               stopListening={stopListening}
//               resetTranscriptData={resetTranscriptData}
//               progress={progress}
//               message={message}
//               aItranscript={aItranscript}
//               hasStarted={hasStarted}
//               setAiTranscript={setAiTranscript}
//               setProgress={setProgress}
//               setMessage={setMessage}
//               targetCharacters={targetCharacters}
//               resetKey={resetKey}
//               transcript={transcript}
//               isSupportedSpeechBrowser={isSupportedSpeechBrowser}
//               wasStopped={wasStopped}
//               setWasStopped={setWasStopped}
//               recordingDuration={recorderVideoDuration}
//             />
//           </div>
//         )}
//         {variant === "testing" ? (
//           <>
//             {status === "stopped" && (
//               <div className="camera-container-footer-testing">
//                 {props.processingUpload ? (
//                   <>
//                     <ProgressBar
//                       varrient={"progress-with-upload-doc"}
//                       value={resource?.upload_percentage}
//                     />
//                   </>
//                 ) : (
//                   <Button
//                     btn="ragular-btn"
//                     varrient="primary-light"
//                     preIcon={
//                       status === "idle" ? <StartIcon /> : <RecordAgainIcon />
//                     }
//                     title={
//                       status === "idle" ? "Start recording" : "Record again"
//                     }
//                     disabled={isSomthingIsInProcess}
//                     onClick={
//                       status === "idle"
//                         ? startRecording
//                         : () => {
//                             setOnRetryModal(true);
//                           }
//                     }
//                   />
//                 )}
//               </div>
//             )}
//           </>
//         ) : (
//           <>
//             {status === "stopped" && (
//               <div
//                 className="w-100 d-flex flex-column align-items-center justify-content-center"
//                 style={{ gap: "12px" }}
//               >
//                 <div className="camera-container-footer">
//                   {isPersonalityTest ? (
//                     <>
//                       {progress < 100 ? (
//                         <div className="w-100 d-flex flex-column align-items-center justify-content-center">
//                           <span className="body-1 white">
//                             {`Almost there! Try re-recording and give a more
//                             complete answer — the progress bar will let you know
//                             when you're good to go.`}
//                           </span>
//                         </div>
//                       ) : (
//                         <>
//                           {props.processingUpload ? (
//                             <ProgressBar
//                               varrient={"progress-with-upload-doc"}
//                               value={resource?.upload_percentage}
//                             />
//                           ) : (
//                             <div
//                               className="w-100 d-flex flex-column align-items-center justify-content-center"
//                               style={{ gap: "5px" }}
//                             >
//                               <CheckIcon />
//                               <span className="body-2 white">Upload Done</span>
//                               <span className="body-4 dark-50">
//                                 You may submit this video or press &quot;Record
//                                 Again&quot; to record a new one
//                               </span>
//                             </div>
//                           )}
//                         </>
//                       )}
//                     </>
//                   ) : (
//                     <>
//                       {props.processingUpload ? (
//                         <ProgressBar
//                           varrient={"progress-with-upload-doc"}
//                           value={resource?.upload_percentage}
//                         />
//                       ) : (
//                         <div
//                           className="w-100 d-flex flex-column align-items-center justify-content-center"
//                           style={{ gap: "5px" }}
//                         >
//                           <CheckIcon />
//                           <span className="body-2 white">Upload Done</span>
//                           <span className="body-4 dark-50">
//                             You may submit this video or press &quot;Record
//                             Again&quot; to record a new one
//                           </span>
//                         </div>
//                       )}
//                     </>
//                   )}
//                 </div>
//                 <div className="w-100 d-flex align-items-center justify-content-center">
//                   <Button
//                     btn="ragular-btn"
//                     varrient="secondary-light"
//                     preIcon={
//                       status === "idle" ? <StartIcon /> : <RecordAgainIcon />
//                     }
//                     title={
//                       status === "idle" ? "Start recording" : "Record again"
//                     }
//                     onClick={
//                       status === "idle"
//                         ? startRecording
//                         : () => {
//                             setOnRetryModal(true);
//                           }
//                     }
//                   />
//                 </div>
//               </div>
//             )}
//           </>
//         )}
//       </div>
//     </>
//   );
// }
